export default {
  data: () => ({
    LocoSeller: {
      key: 'locoSeller',
      value: 'Oferta z transportem odpadu'
    },
    LocoBuyer: {
      key: 'locoBuyer',
      value: 'Oferta bez transportu odpadu'
    },
    Others: {
      key: 'others',
      value: 'Inne (patrz uwagi)'
    }
  }),
  methods: {
    getTransportConditions() {
      return [this.LocoSeller, this.LocoBuyer, this.Others]
    },
    getTransportConditionLabel(value) {
      const result = this.getTransportConditions().find(
        (tc) => tc.key === value
      )

      return result ? result.value : ''
    },
    isLocoSellerTransportCondition(value) {
      return this.LocoSeller.key === value
    },
    isLocoBuyerTransportCondition(value) {
      return this.LocoBuyer.key === value
    },
    isOtherTransportCondition(value) {
      return this.Others.key === value
    }
  }
}
